import { useCallback } from 'react';

import { api } from '~/lib/api';

type RegenerateScoringResult = {
  competencyName: string;
  score1: string;
  score3: string;
  score5: string;
};

export function useRegenerateScoring(
  orgId: string,
  deptId: string,
  jobId: string | null
): (questionText: string) => Promise<RegenerateScoringResult | null> {
  return useCallback(
    async (questionText: string): Promise<RegenerateScoringResult | null> => {
      if (!jobId) return null;
      try {
        const res = await api.api.org[':orgId'].department[':deptId'].jobs[':jobId'][
          'interview-setup'
        ].questions['regenerate-scoring-examples'].$post({
          param: { orgId, deptId, jobId },
          json: { questionText }
        });
        if (!res.ok) return null;
        return await res.json();
      } catch {
        return null;
      }
    },
    [orgId, deptId, jobId]
  );
}
